export default "__VITE_ASSET__Cp_4$cbT__"